<template>
  <v-container fluid class="mx-0 px-0" v-if="showIregistruoti">
    <h3 class="mb-3">{{ $t('Įregistruoti dokumentai') }}</h3>
    <v-data-table
      :loading="loading"
      :headers="filteredHeaders"
      :items="filterItemList"
      :search="search"
      :hide-default-footer="hideFooter"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: this.$t('Rodyti po:'),
        itemsPerPageAllText: this.$t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
    >
      <template #[`item.dokumentas`]="{ item }">
        <v-row dense no-gutters>
          <v-col cols="12" md="12">
            <el-prasymas-busena
              class="my-1"
              :busena="item.pra_busena_pavadinimas"
            />
          </v-col>
          <v-col cols="12" md="12">
            <b>{{ item.pra_id }}</b>
          </v-col>
          <v-col cols="12" md="12">
            {{ item.pra_tipas_pavadinimas }}
          </v-col>
        </v-row>
      </template>
      <template #[`item.turtas`]="{ item }">
        <v-row dense no-gutters>
          <v-col
            v-for="turtas in item.turtai"
            :key="turtas[0]"
            class="mb-2"
            cols="12"
            md="12"
          >
            <div>{{ turtas[0] }}</div>
            <div>{{ turtas[1] }}</div>
          </v-col>
          <v-col cols="12" md="12" v-if="item.turtaiCut">
            ...
          </v-col>
        </v-row>
      </template>
      <template #[`item.pra_sukurimo_data`]="{ item }">
        <div class="nowrap center">{{ item.pra_sukurimo_data }}</div>
      </template>
      <template #[`item.actions`]="{ item }">
        <el-button
          small
          v-if="showNaujasPrasymas && !item.negalima_kurti"
          :loading="prasymasLoading"
          @click.native.stop="naujasPrasymas(item.dok_id)"
        >
          {{ naujasPrasymasTitle }}
        </el-button>
      </template>
      <template slot="loading">
        {{ $t('Kraunasi...') }}
      </template>
      <template slot="no-results">
        {{ $t('Duomenų nėra') }}
      </template>
      <template slot="no-data">
        {{ $t('Duomenų nėra') }}
      </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
        {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'
import busenaNtrTipas from '@/mixins/busenaNtrTipas'

export default {
  name: 'PrasymasListIregistruoti',
  components: {},
  mixins: [userRole, busenaNtrTipas],
  props: {
    prasymasTipasFilter: String,
    naujasPrasymasTitle: String,
    rengiamiLength: Number,
  },
  data() {
    return {
      pageloading: true,
      loading: true,
      prasymasLoading: false,
      showError: false,
      errorText: null,
      search: null,
      showDelete: false,
      modalDeleteVardas: '',
      modalDeleteItem: null,
      prasymas: [],
      searchData: {},
      itemsPerPageOptions: [10, 50, -1],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    ...mapGetters(['listInfo']),

    headers() {
      return [
        {
          text: this.$t('Dokumentas'),
          align: 'start',
          value: 'dokumentas',
          width: 190,
        },
        {
          text: this.$t('Dokumento šalis'),
          align: 'start',
          sortable: false,
          value: 'salis',
          hide: this.hideSalis,
        },
        {
          text: this.$t('Nekilnojamasis turtas'),
          align: 'start',
          sortable: false,
          value: 'turtas',
        },
        {
          text: this.$t('Data'),
          align: 'center',
          value: 'pra_sukurimo_data',
          width: 80,
        },
        {
          text: this.$t('Veiksmai'),
          align: 'start',
          sortable: false,
          value: 'actions',
          width: 50,
          hide: !this.showNaujasPrasymas,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter(item => {
        return !item.hide
      })
    },
    filterItemList() {
      return this.prasymas.map(prasymas => {
        const maxTurtai = 3
        prasymas.turtaiCut = false
        if (prasymas.turtai.length > maxTurtai) {
          prasymas.turtai = prasymas.turtai.slice(0, maxTurtai)
          prasymas.turtaiCut = true
        }

        if (prasymas.pra_busena === 'laukia_patvirtinimo') {
          prasymas.pra_busena_pavadinimas = this.$t('Laukia pasirašymo')
        }

        prasymas.canView = true
        return prasymas
      })
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
    hideSalis() {
      return this.isPrasymasSeima || this.isPrasymasBendra
    },
    prasymasTipas() {
      return this.prasymasTipasFilter
    },
    showIregistruoti() {
      return this.prasymas.length > 0
    },
    showNaujasPrasymas() {
      if (
        this.isPrasymasNuoma ||
        this.isPrasymasPanauda ||
        this.isPrasymasSubnuoma ||
        this.isPrasymasPreliminari
      ) {
        return this.naujasPrasymasTitle
      }
      return this.rengiamiLength === 0 && this.naujasPrasymasTitle
    },
    isSeimaIsregistravimas() {
      return this.prasymasTipas === 'seima-isregistravimas'
    },
  },
  created() {
    this.pageloading = true
    this.loading = true
    this.getData()
  },
  methods: {
    getData() {
      this.$axios
        .post(
          `ntrpaslaugos/iregistruoti-dokumentai/${this.prasymasTipasFilter}`
        )
        .then(res => {
          this.prasymas = res.data.prasymas
          this.pagination.total = this.prasymas.length
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loading = false
          this.$emit('loaded', this.prasymas.length)
        })
    },
    naujasPrasymas(dokId) {
      this.prasymasLoading = true

      if (this.isSeimaIsregistravimas) {
        this.$emit('prasymasPagrindas', dokId)
        return
      }

      this.$emit('naujasPrasymas', dokId)
    },
  },
}
</script>
<style lang="scss" scoped></style>
